import React, { useLayoutEffect, useState } from 'react';

import { getSystemColorScheme } from '@utils';

import { useStore } from '@modules';

const OPTIONS = {
  title: 'Mercuryo',
  title2: 'Crypto Wallet for Everyday Use',
  description:
    'Mercuryo allows you to buy the most popular crypto currencies BTC, ETH, USDT, BAT, ALGO and others with your bank card as well as transfer money around the world in a few taps. Buy, transfer or quickly and easily withdraw crypto currency to your bank card. Crypto made easy!',
  og_description: 'Buy and sell the most popular crypto currencies with your bank card.',
};

const faviconDir = `/img/favicon/${getSystemColorScheme()}`;
const getMainBg = () => getComputedStyle(document.body).getPropertyValue('--color-main-bg');

const Head: CustomFC = () => {
  const [{ global }] = useStore();
  const { scheme } = global;
  const [metaColor, setMetaColor] = useState(getMainBg());

  useLayoutEffect(() => {
    document.body.classList.add('no-transitions');
    document.documentElement.setAttribute('data-scheme', scheme);
    setTimeout(() => {
      document.body.classList.remove('no-transitions');
    }, 1);
    setMetaColor(getMainBg());
  }, [scheme]);

  return (
    <>
      <title>{`${OPTIONS.title} | ${OPTIONS.title2}`}</title>
      <meta name="title" content={`${OPTIONS.title} | ${OPTIONS.title2}`} />
      <meta name="description" content={OPTIONS.description} />
      <meta property="og:site_name" content={OPTIONS.title} />
      <meta property="og:title" content={OPTIONS.title2} />
      <meta property="og:description" content={OPTIONS.og_description} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={OPTIONS.title} />
      <meta property="twitter:description" content={OPTIONS.og_description} />
      <meta property="og:image" content="https://mercuryo.io/static/img/link_preview.png" />
      <meta property="og:url" content="https://my.mercuryo.io" />
      <link rel="apple-touch-icon" sizes="180x180" href={`${faviconDir}/apple-touch-icon.png`} />
      <link rel="icon" type="image/png" sizes="32x32" href={`${faviconDir}/favicon-32x32.png`} />
      <link rel="icon" type="image/png" sizes="16x16" href={`${faviconDir}/favicon-16x16.png`} />
      <link rel="manifest" href={`${faviconDir}/site.webmanifest`} />
      <meta name="theme-color" content={metaColor} />
    </>
  );
};

export default Head;
